import React from 'react';
import { useParams } from 'react-router-dom';

const QuestionnairePage: React.FC = () => {
    const { questionnaireId } = useParams<{ questionnaireId: string }>();
    return <div>TODO: QuestionnairePage {questionnaireId}</div>;
};

export default QuestionnairePage;
